var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6V24H3V22H4V23H20V7H14V1H4V13H3V0H15L21 6ZM15 6H19.5L15 1.5V6Z",
    fill: "#040404"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 20,
    height: 9,
    rx: 1,
    fill: "#C80404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98306 15.006C8.132 15.0099 9 15.4556 9 17.0041C9 18.5041 7.99005 19.0193 6.94345 19.0157H5.98061V19.9945L5 19.9979L5.01296 15.006H6.98306ZM7 18.0041C7.70977 18.0065 7.9983 17.6412 8 17.0041C8.0017 16.3671 7.70973 16.0064 7 16.0041H6L5.98061 18.0041H7ZM10.013 15.0038H12C13.4303 15.0086 14.0035 16.1335 14 17.5038C13.9964 18.8828 13.4374 20.0034 12 19.9987L10 19.9956L10.013 15.0038ZM12 19.0157C12.9918 19.019 13 18.1366 13 17.5038C13 17.0041 12.9692 16.0071 12 16.0038H11V19.0038L12 19.0157ZM16 16V16.9997L18 17V17.9997H16V19.9946L15 19.9919L15.013 15L19 15.0083V16H16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.73c4829b7a5fd5c14aad6f1d20c568d1.svg";
export { ForwardRef as ReactComponent };